import "./StartPro.css"

function StartPro(){

    return(
        <>
        <div className="startPro_contain">
            <div className="startPro_contain_left">
                <div className="line"></div>
                <h1>Complete Home Care You Can<span> Trust</span></h1>
                <p>
Professional home maintenance services in Dubai including electrical repairs, plumbing works, AC maintenance, painting, carpentry, tiling, and complete property maintenance solutions. We provide reliable, affordable, and fast maintenance services for villas, apartments, homes, and commercial properties across Dubai.
</p>
            </div>
            <div className="startPro_contain_right">
                <button
  onClick={() =>
    window.open(
      "https://wa.me/971521743345?text=Hi%20I%20need%20an%20estimate",
      "_blank"
    )
  }
>
  Get an Estimate
</button>
            </div>
        </div>
        </>
    )
}
export default StartPro